import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ALL_PACKAGES, IPackageCardData } from 'app/common/ui/k-cards/k-package-card/k-package-card.interface';
import { formatNum } from 'app/common/utils/number.util';
import { CoinService } from 'app/services/coin/coin.service';
import { first } from 'rxjs';

@Component({
  selector: 'package-buy-modal',
  templateUrl: './package-buy-modal.component.html',
  styleUrls: ['./package-buy-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PackageBuyModalComponent {

  @Input() visible: boolean = false;
  @Output() isVisible: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() wallet: string;
  packageCardsData: IPackageCardData[] = ALL_PACKAGES()
  showOnramper: boolean = false;
  amountSelectedOnramper: number;
  kmonPriceData: any;

  constructor(private coinService: CoinService) {
    this.coinService.getKmonPrice().pipe(first()).subscribe(
      result => {
        this.kmonPriceData = result;
        let kmonPrice = result.kryptomon.usd;
        let bnbAmount = Math.round((5 / result.wbnb.usd) * 100) / 100;
        this.overwritePackageCardData(kmonPrice, bnbAmount);
      }
    );
  }

  onHide() {
    this.isVisible.emit(this.visible);
  }

  overwritePackageCardData(kmonPrice: number, bnbAmount: number) {
    this.packageCardsData.forEach(
      packageData => {
        let dollarAmount: number = parseFloat(packageData.dollarAmount.replace('$', ''));
        let kmonAmount: number = (Math.round((dollarAmount - 5) / kmonPrice * 100) / 100);
        packageData.goldenLabel = formatNum(kmonAmount);
        packageData.KMONAmount = formatNum(kmonAmount);
        packageData.BNBAmount = bnbAmount + '';
      }
    )
  }

  onCardClick(packageSelected: IPackageCardData) {
    this.amountSelectedOnramper = parseFloat(packageSelected.dollarAmount.replace('$', ''));
    this.visible = false;
    this.showOnramper = true;
  }

}
